import '@gitg/rcm-ip-component-library';

// eslint-disable-next-line import/no-default-export
export default async (): Promise<void> => {
  /**
   * The code to be executed should be placed within a default function that is
   * exported by the global script. Ensure all of the code in the global script
   * is wrapped in the function() that is exported.
   */
};
